import router from './router'
// import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
// import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { authIsSuccess } from './views/ShopManagement/api/login'
import store from '@/store'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  document.title = getPageTitle(to.meta.title)

  // const hasToken = getToken()

  // if (hasToken) {
  const t = true
  console.log('path', to.path)
  console.log('to.query :>> ', to.query);
  if (t) {
    // console.log(to.path)
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else if (to.path === '/shop-management') {
      const token = localStorage.getItem("token");
      console.log('token :>> ', token);
      console.log('to.query.type :>> ', to.query.type);
      await store.dispatch("shopManagement/setFromType", to.query.type);
      if (!token) {
        next({
          path: '/shop-management/login',
          replace: true
        });
      } else {
        const res = await authIsSuccess();
        console.log('res :>> ', res);
        if (res.code > 200) {
          next({
            path: '/shop-management/login',
            replace: true
          });
          return;
        }
        await store.dispatch("shopManagement/setUser", res.data);
        if (res.data.status == 2) {
          next({
            path: '/shop-management/management-index',
            replace: true
          });
        } else {
          next({
            path: '/shop-management/edit-information',
            replace: true,
            query: { status: res.data.status }
          });
        }
      }
      NProgress.done()
    } else {
      // console.log('1')
      next()
    }

  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to, from) => {
  // if (to.path.indexOf("shop-management") >= 0) {
  //   const toDepth = to.path.split('/').length
  //   const fromDepth = from.path.split('/').length
  //   to.meta.transition = toDepth < fromDepth ? 'slide-right' : 'slide-left'
  // }
  NProgress.done()
})
